import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Quote } from 'app/entities/quote';
import { QuotesService } from '../quote-list/quotes.service';
import { AlertService } from 'app/services/alert.service';

@Component({
  selector: 'app-preview-quote',
  templateUrl: './preview-quote.component.html',
  styleUrls: ['./preview-quote.component.scss'],
})
export class PreviewQuoteComponent implements OnInit {
  quote: Quote;
  loadingOrcar = false;

  constructor(
    public dialogRef: MatDialogRef<PreviewQuoteComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _router: Router,
    private _quotesService: QuotesService,
    private _alertService: AlertService
  ) {
    this.quote = _data.quote;
  }

  ngOnInit(): void {}

  orcar(): void {
    if (!this.quote?.id || this.loadingOrcar) {
      return;
    }

    this.loadingOrcar = true;
    this._quotesService.proposalDraft(this.quote.id).subscribe(
      (draft: any) => {
        this.loadingOrcar = false;
        this.dialogRef.close();

        if (draft?.alreadyConverted && draft?.proposal?.token) {
          this._router.navigate(['/propostas', draft.proposal.token]);
          return;
        }

        this._router.navigate(['/propostas', 'new'], {
          state: {
            proposalDraft: draft,
          },
        });
      },
      (err) => {
        this.loadingOrcar = false;
        this._alertService.error(err);
      }
    );
  }
}
